export default {
  createANewConsumable: "Create a new consumable item",
  equipmentTag: "Asset Tag",
  createdBy: "Created by",
  name: "Name",
  initialDate: "Initial Date",
  lifetime: "Lifetime",
  alertTime: "Alert Time",
  alertMessage: "The alert time have to be less than the lifetime",
  greaterThanZero: "This field have to be greater than 0.",
  mandatoryField: "This field is mandatory.",
  submit: "Crear",
  year: "Year",
  month: "Month",
  week: "Week",
  day: "Day"
};
